<template>
  <div>
    <a-color-field
      varName="branding_options.color.primary"
      varLabel="Primary Color"
      :varRequired="true"
      :varInitial="data.branding_options.color.primary"
      :formLayout="formLayout"
      :size="size"
    />
    <a-color-field
      varName="branding_options.color.background"
      varLabel="Background Color"
      :varRequired="true"
      :varInitial="data.branding_options.color.background"
      :formLayout="formLayout"
      :size="size"
    />
    <a-color-field
      varName="branding_options.color.info"
      varLabel="Info Color"
      :varRequired="true"
      :varInitial="data.branding_options.color.info"
      :formLayout="formLayout"
      :size="size"
    />
    <a-color-field
      varName="branding_options.color.danger"
      varLabel="Danger Color"
      :varRequired="true"
      :varInitial="data.branding_options.color.danger"
      :formLayout="formLayout"
      :size="size"
    />
    <a-color-field
      varName="branding_options.color.warning"
      varLabel="Warning Color"
      :varRequired="true"
      :varInitial="data.branding_options.color.warning"
      :formLayout="formLayout"
      :size="size"
    />
    <a-color-field
      varName="branding_options.color.success"
      varLabel="Success Color"
      :varRequired="true"
      :varInitial="data.branding_options.color.success"
      :formLayout="formLayout"
      :size="size"
    />
    <a-color-field
      varName="branding_options.color.secondary"
      varLabel="Secondary Color"
      :varRequired="true"
      :varInitial="data.branding_options.color.secondary"
      :formLayout="formLayout"
      :size="size"
    />
    <a-text-field
      varName="branding_options.name"
      varLabel="Name"
      :varRequired="true"
      :varInitial="data.branding_options.name"
      :formLayout="formLayout"
      :size="size"
    />
    <a-text-area-field
      varName="branding_options.description"
      varLabel="Description"
      :varRequired="true"
      :varInitial="data.branding_options.description"
      :formLayout="formLayout"
      :size="size"
    />
    <a-select-field
      varName="branding_options.form_size"
      varLabel="Form Size"
      :varRequired="true"
      :varInitial="data.branding_options.form_size"
      :formLayout="formLayout"
      :size="size"
      :varOptions="form_size"
      type="array"
    />
    <a-url-field
      varName="branding_options.logo"
      varLabel="Logo"
      :varRequired="true"
      :varInitial="data.branding_options.logo"
      :formLayout="formLayout"
      :size="size"
      icon="picture"
    />
    <a-switch-field
      varName="branding_options.display_logo_only"
      varLabel="Display logo only"
      :varRequired="true"
      :varInitial="data.branding_options.display_logo_only"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
    />
    <a-url-field
      varName="branding_options.favicon"
      varLabel="Favicon"
      :varRequired="true"
      :varInitial="data.branding_options.favicon"
      :formLayout="formLayout"
      :size="size"
      icon="picture"
    />
    <a-url-field
      varName="branding_options.image_side"
      varLabel="Side image"
      :varRequired="false"
      :varInitial="data.branding_options.image_side"
      :formLayout="formLayout"
      :size="size"
      icon="picture"
    />
    <a-url-field
      varName="branding_options.contact.website"
      varLabel="Brand Website"
      :varRequired="false"
      :varInitial="data.branding_options.contact.website"
      :formLayout="formLayout"
      :size="size"
      icon="link"
    />
    <a-text-misc-field
      varName="branding_options.contact.email"
      varLabel="Contact Email"
      :varRequired="false"
      :varInitial="data.branding_options.contact.email"
      :formLayout="formLayout"
      :size="size"
      type="email"
    />
    <a-text-field
      varName="branding_options.contact.address"
      varLabel="Contact Address"
      :varRequired="false"
      :varInitial="data.branding_options.contact.address"
      :formLayout="formLayout"
      :size="size"
    />
    <a-text-area-field
      varName="branding_options.custom_css"
      varLabel="Custom CSS"
      :varRequired="false"
      :varInitial="data.branding_options.custom_css"
      :formLayout="formLayout"
      :size="size"
    />
    <a-auto-complete-select
      varName="branding_options.headline_font"
      varLabel="Headline Font Family"
      :varRequired="true"
      :varInitial="data.branding_options.headline_font"
      :formLayout="formLayout"
      :size="size"
      :data="dataSource"
    />
    <a-auto-complete-select
      varName="branding_options.body_font"
      varLabel="Body Font Family"
      :varRequired="true"
      :varInitial="data.branding_options.body_font"
      :formLayout="formLayout"
      :size="size"
      :data="dataSource"
    />
  </div>
</template>

<script>
import GoogleFonts from "@/data/google-fonts-top100.json";
import _ from "lodash";

export default {
  data() {
    return {
      form_size: ["small", "large", "big", "huge", "massive"],
      dataSource: _.map(GoogleFonts, "family")
    };
  },
  props: {
    formLayout: String,
    size: String,
    data: Object
  }
};
</script>